import { SectionBody } from "../../section-layout";

export function JobsEmpty() {
  return (
    <SectionBody className="items-center justify-center gap-1">
      <p className="text-sm text-foreground/70">No jobs found</p>
      <p className="text-xs text-foreground/40">
        This profile hasn&apos;t been added to any job yet.
      </p>
    </SectionBody>
  );
}
